import React from "react";
import { useParams } from 'react-router-dom';

import ListPermissions from './ListPermissions'
import List from './List'

const Component = () => {
    const { _id } = useParams()
    return (
        <>
            <ListPermissions>
                <List user={_id} showColumns={[0,1,2,3]} />
            </ListPermissions>
        </>
    );
};

export default Component;
